import { ethers } from 'ethers';

export const YELLOWSTONE_NETWORK_ID = '0x2ac54';
export const LITCHAIN_NETWORK_ID = '0x2ac60'; // 175200

export const getSigner = async () => {
  // A Web3Provider wraps a standard Web3 provider, which is
  // what MetaMask injects as window.ethereum into each page
  const provider = new ethers.providers.Web3Provider((window as any).ethereum);

  // MetaMask requires requesting permission to connect users accounts
  await provider.send('eth_requestAccounts', []);

  // The MetaMask plugin also allows signing transactions to
  // send ether and pay to change state within the blockchain.
  // For this, you need the account signer...
  const signer = provider.getSigner();
  return signer;
};

export const getProvider = async () => {
  // A Web3Provider wraps a standard Web3 provider, which is
  // what MetaMask injects as window.ethereum into each page
  const provider = new ethers.providers.Web3Provider((window as any).ethereum);

  // MetaMask requires requesting permission to connect users accounts
  await provider.send('eth_requestAccounts', []);

  return provider;
};

export const switchToYellowstoneNetwork = async () => {
  const { ethereum } = window;
  if (!ethereum) {
    throw new Error('No compatible Web3 wallet extension found');
  }

  // Add Yellowstone Network if it doesn't exist
  await ethereum.request({
    method: 'wallet_addEthereumChain',
    params: [
      {
        chainId: YELLOWSTONE_NETWORK_ID,
        rpcUrls: ['https://yellowstone-rpc.litprotocol.com'],
        chainName: 'Chronicle Yellowstone - Lit Protocol Testnet',
        nativeCurrency: {
          name: 'tstLPX',
          symbol: 'tstLPX',
          decimals: 18,
        },
        blockExplorerUrls: ['https://yellowstone-explorer.litprotocol.com'],
      },
    ],
  });
  // Switch to Yellowstone Network
  await ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: YELLOWSTONE_NETWORK_ID }],
  });
};

export const switchToLitChainNetwork = async () => {
  const { ethereum } = window;
  if (!ethereum) {
    throw new Error('No compatible Web3 wallet extension found');
  }

  // Add LitChain Network if it doesn't exist
  await ethereum.request({
    method: 'wallet_addEthereumChain',
    params: [
      {
        chainId: LITCHAIN_NETWORK_ID,
        rpcUrls: ['https://lit-chain-rpc.litprotocol.com'],
        chainName: 'LitChain - Lit Protocol',
        nativeCurrency: {
          name: 'LITKEY',
          symbol: 'LITKEY',
          decimals: 18,
        },
        blockExplorerUrls: ['https://lit-chain-explorer.litprotocol.com'],
      },
    ],
  });
  // Switch to LitChain Network
  await ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: LITCHAIN_NETWORK_ID }],
  });
};
